// removed by extract-text-webpack-plugin
module.exports = {"OrderTotal":"OrderTotal__OrderTotal__19B1t"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/OrderTotal/OrderTotal.css
// module id = 244
// module chunks = 1